const lightColors = {
  background: {
    shadesPurple: '#6324C6',
    gray: ' #A7B0BE',
    main: '#ffffff',
    border: '#4C5667',
    fill: '#FFB800',
  },
  text: {
    primary: '#000000',
    contrastText: '#ffffff',
    purple: '#6324C6',
    secondary: '#4C5667',
    title: '#FFB800',
    header: '#ffffff',
    button: '#ffffff',
  },
};

const darkColors = {
  background: {
    shadesPurple: '#483F8D',
    gray: ' #A7B0BE',
    main: '#322C63',
    border: '#ffffff',
    fill: '#000000',
  },
  text: {
    primary: '#ffffff',
    contrastText: '#000000',
    purple: '#7D41DC',
    secondary: '#d5d5d5',
    title: '#FFB800',
    header: '#ffffff',
    button: '#ffffff',
  },
};

export { lightColors, darkColors };
